export class BillingUser {
    public email: string = "";
    public address: string = "";
    public city: string = "";
    public state: string = "";
    public country: string = "";
}